import { createRouter, createWebHistory } from 'vue-router'
import { useUserStore } from '@app/store/user'
const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: () => import('../views/DashboardPage.vue'),
    meta: { layout: 'main', auth: true },
  },
  {
    path: '/users',
    name: 'UserManagement',
    component: () => import('../views/UserManagement.vue'),
    meta: { layout: 'main', auth: true },
  },
  {
    path: '/targets',
    name: 'Targets',
    component: () => import('../views/targets/TargetsPage.vue'),
    meta: { layout: 'main', auth: true },
  },
  {
    path: '/kpi',
    name: 'KPI',
    component: () => import('../views/kpi/KpiPage.vue'),
    meta: { layout: 'main', auth: true },
  },
  {
    path: '/kpi-details',
    name: 'KPIDetails',
    component: () => import('../views/kpiDetails/KpiDetailsPage.vue'),
    meta: { layout: 'main', auth: true }
  },
  {
    path: '/score-details',
    name: 'ScoreDetails',
    component: () => import('../views/scoreDetails/ScoreDetailsPage.vue'),
    meta: { layout: 'main', auth: true }
  },
  {
    path: '/score-card',
    name: 'ScoreCard',
    component: () => import('../views/scoreCard/ScoreCard.vue'),
    meta: { layout: 'main', auth: true }
  },
  {
    path: '/sign_in',
    name: 'SignIn',
    component: () => import('../views/auth/SignIn.vue'),
    meta: { layout: 'auth', auth: false },
    beforeEnter: (_to, _from, next) => {
      const userStore = useUserStore()
      if (userStore.user) {
        next({ name: 'Dashboard' })
      } else {
        next()
      }
    },
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  linkActiveClass: 'active',
  exactActiveClass: 'active',
})

router.beforeEach(async (to, from, next) => {
  const requireAuth = to.meta.auth
  const userStore = useUserStore()
  if (!userStore.isInitialized) {
    await userStore.fetchUser()
  }
  next()
  if (requireAuth && !userStore.user && to.path !== '/sign_in') {
    next({ name: 'SignIn' })
  } else {
    next()
  }
})

export default router
